import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {some, sortBy} from 'lodash';

export default function trucksReducer(state = initialState.trucks, action) {
  switch (action.type) {
    case types.LOAD_TRUCKS_SUCCESS:
      return {...state, ...action.trucks};
    case types.SAVE_TRUCK_SUCCESS:
      let trucks = [...state.items];
      let truck = {...action.truck};
      if (_.some(trucks, x => x.id == truck.id)) {
        trucks = [...state.items.map(x => {
          let returnVal = {...x};
          if (returnVal.id == truck.id) {
            return truck;
          }
          return returnVal;
        })];
      } else {
        trucks[trucks.length] = truck;
      }
      console.log(state);
      return {...state, items: _.sortBy(trucks, x => x.name.toLowerCase())};

    case types.DELETE_TRUCK_SUCCESS:
      return {...state, items: [...state.items.filter(x => x.id != action.truck.id)]};
    case types.LOAD_COLLECTION_TYPES_SUCCESS:
      console.log(state, action);
      return {...state, collectionTypes: action.collectionTypes};
    default:
      return state;
  }
}
